import type { BadgeId } from "../types";
import lockedBadgeUrl from "../assets/locked-badge.png";

// Shared "not yet earned" medallion shown in place of a locked badge's real
// art, hiding which achievement it is until unlocked.
export const lockedBadgeArt = lockedBadgeUrl;

// Vite resolves each badge image to a hashed, build-time URL. Keying by the
// file's basename means a new badge just needs its art dropped in
// src/assets/badges/<id>.{png,svg} — no edit here. PNG (painted art) and SVG
// (vector emblems) are both supported.
const modules = import.meta.glob<string>("../assets/badges/*.{png,svg}", {
  eager: true,
  import: "default",
});

const ART: Partial<Record<BadgeId, string>> = {};
for (const [path, url] of Object.entries(modules)) {
  const id = path.split("/").pop()!.replace(/\.(png|svg)$/, "") as BadgeId;
  ART[id] = url;
}

/** Hashed URL for a badge's artwork, or undefined if no art ships for it. */
export function badgeArt(id: BadgeId): string | undefined {
  return ART[id];
}
